exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._table-users .row-user{cursor:pointer}._table-users .row-user td:first-child{width:100%;white-space:nowrap;display:flex;align-items:center}._table-users .row-user td:last-child{white-space:nowrap}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/stylus-loader!./src/components/plain/tableUsers/tableUsers.styl
// module id = 453
// module chunks = 0